module.exports = __webpack_public_path__ + "img/AddHSSK.1878d53a.svg";